// extracted by mini-css-extract-plugin
export default {"menuIcon":"HamburgerMenuIcon_menuIcon__A-L6H"};